import cn from 'classnames';

const CustomCell = (
  id,
  value = '',
  className,
  router,
  redirectUrl,
  state = {},
) => ({
  id,
  render: () => value,
  getCellProps: () => ({
    className: cn(className, 'text-16 font-normal'),
    onClick: () =>
      redirectUrl &&
      router.push({
        pathname: redirectUrl,
        state,
      }),
  }),
});

export default CustomCell;
